export default "__VITE_ASSET__dd174301__"